/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BGGGameDetails } from '../models/BGGGameDetails';
import type { BGGSearchResult } from '../models/BGGSearchResult';
import type { GameOutput } from '../models/GameOutput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GamesService {
    /**
     * Search BoardGameGeek
     * Search for board games on BoardGameGeek by name
     * @returns BGGSearchResult Successful Response
     * @throws ApiError
     */
    public static searchBggGamesBggSearchGet({
        query,
        limit = 10,
        includeExpansions = false,
    }: {
        /**
         * Search query for game name
         */
        query: string,
        /**
         * Maximum number of results to return
         */
        limit?: number,
        /**
         * Whether to include game expansions in search results
         */
        includeExpansions?: boolean,
    }): CancelablePromise<Array<BGGSearchResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/bgg/search',
            query: {
                'query': query,
                'limit': limit,
                'includeExpansions': includeExpansions,
            },
            errors: {
                400: `Invalid request - query required`,
                500: `Server error or BGG API unavailable`,
            },
        });
    }
    /**
     * Get BGG Game Details
     * Get detailed game information from BoardGameGeek
     * @returns BGGGameDetails Successful Response
     * @throws ApiError
     */
    public static getBggGameDetailsGamesBggBggIdGet({
        bggId,
    }: {
        /**
         * BoardGameGeek game ID
         */
        bggId: number,
    }): CancelablePromise<BGGGameDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/bgg/{bgg_id}',
            path: {
                'bgg_id': bggId,
            },
            errors: {
                404: `Game not found on BGG`,
                500: `Server error or BGG API unavailable`,
            },
        });
    }
    /**
     * Import BGG Image
     * Download an image from BoardGameGeek and save it to S3 for a game
     * @returns GameOutput Successful Response
     * @throws ApiError
     */
    public static importBggImageGamesGameIdImportBggImagePost({
        gameId,
        imageUrl,
    }: {
        /**
         * Game ID
         */
        gameId: string,
        /**
         * URL of the BGG image to import
         */
        imageUrl: string,
    }): CancelablePromise<GameOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/import-bgg-image',
            path: {
                'game_id': gameId,
            },
            query: {
                'image_url': imageUrl,
            },
            errors: {
                400: `Invalid image URL (only BGG URLs allowed)`,
                404: `Game not found`,
                500: `Server error or failed to download image`,
            },
        });
    }
}
